
import { Enums } from '@bode-canada/core';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType, StyleSizeType, StylePositionType } from '@/ui-kit/styles/enums';
import Gutter from '@/ui-kit/components/gutter';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import Typography from '@/ui-kit/components/typography';
import Icon from '@/ui-kit/components/icon';
import { IconType, IconProperty } from '@/ui-kit/components/icon/enums';
import Button from '@/ui-kit/components/button';
import { ButtonFillType, ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { ToastMessage } from '@/ui-kit/components/toast/enums';
import SpinnerModal from '@/ui-kit/components/modal/spinner';
import ModalService from '@/ui-kit/components/modal/ModalService';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import LocalStorageService from '@/services/LocalStorageService/LocalStorageService';
import { LocalStorageItemKey } from '@/services/LocalStorageService/enums';
import MyListingsApiService from '@/services/api/serverless/my-listings';
import { QueryParams } from '@/constants/QueryParams';
import routes, { SUBMIT_SUCCESS } from '@/constants/routes';
import ToastService from '@/components/toast/toast-service';
import ListingsApiService from '@/services/api/listings';
import { getListingFlowSteps } from '../enums';

const { ListingStatusEnum } = Enums;

export default {
  name: 'ListingPreviewAccordionContent',
  components: {
    Typography,
    Gutter,
    Button,
    Icon,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    isDraftStatus: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      required: true,
    },
    isUserTitleHolder: {
      type: Boolean,
      required: true,
    },
    isUserAdmin: {
      type: Boolean,
      default: false,
    },
    hasAgreement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TypographyType,
      TypographyProperty,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
      IconType,
      IconProperty,
      ButtonFillType,
      ButtonProperty,
      ButtonPropsEventType,
      GutterProperty,
      isLoading: false,
      canSubmit: false,
    };
  },
  computed: {
    isButtonDisabled() {
      return this.isLoading;
    },
    isUserTitleHolderOrAdmin() {
      return this.isUserTitleHolder || this.isUserAdmin;
    },
    steps() {
      return getListingFlowSteps(this.isRelistMode);
    },
    isRelistMode() {
      return [
        Enums.ListingStatusEnum.EXPIRED,
        Enums.ListingStatusEnum.TERMINATED,
        Enums.ListingStatusEnum.HIDDEN,
      ].includes(this.status);
    },
  },
  mounted() {
    this.canSubmit = LocalStorageService.fetch(LocalStorageItemKey.CanSubmitListing);
    LocalStorageService.remove(LocalStorageItemKey.CanSubmitListing);
  },
  methods: {
    handleSubmitListingClick() {
      this.submitting = true;
      this.trackEvent(ListingPageEvent.SubmitListing);

      this.submitListing();
    },
    async submitListing() {
      ModalService.open({ component: SpinnerModal });

      try {
        this.submitting = true;

        await MyListingsApiService.updateListingStatus(this.id, ListingStatusEnum.SUBMITTED);

        await this.createListingAgreementUrl(false);
        this.$router.push(`${routes.listings}/${this.id}${SUBMIT_SUCCESS}`);
        this.openSubmitPositiveToast(this.isRelistMode);
      } catch {
        this.openSubmitNegativeToast(this.isRelistMode);
      } finally {
        this.submitting = false;
        ModalService.close();
      }
    },
    async handleRelistClick() {
      await this.submitListing();
    },
    handleEditClick() {
      this.trackEvent(ListingPageEvent.EditListing);
      this.navigateToEditPage();
    },
    navigateToEditPage(query) {
      this.$router.push({
        path: routes.listHome,
        query: {
          [QueryParams.ListingId]: this.id,
          ...(query || {}),
        },
      });
    },
    createListingAgreementUrl(isResend) {
      return ListingsApiService.getListingAgreementUrl(this.id, isResend);
    },
    openSubmitPositiveToast(isRelist) {
      return isRelist
        ? ToastService.openPositive(ToastMessage.RelistListing)
        : ToastService.openPositive(ToastMessage.AgreementHasBeenSent);
    },
    openSubmitNegativeToast(isRelist) {
      return isRelist
        ? ToastService.openNegative(ToastMessage.RelistListingFail)
        : ToastService.openNegative(ToastMessage.AgreementSendError);
    },
    trackEvent(event) {
      this.$track(event, { listingId: this.id });
    },
  },
};
